import { render, staticRenderFns } from "./OfertaSolicitudBase.vue?vue&type=template&id=59b55fa4"
import script from "./OfertaSolicitudBase.vue?vue&type=script&lang=js"
export * from "./OfertaSolicitudBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59b55fa4')) {
      api.createRecord('59b55fa4', component.options)
    } else {
      api.reload('59b55fa4', component.options)
    }
    module.hot.accept("./OfertaSolicitudBase.vue?vue&type=template&id=59b55fa4", function () {
      api.rerender('59b55fa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Simuladores/Ofertas/solicitud/OfertaSolicitudBase.vue"
export default component.exports